//
// Copyright (c) 2011-2024 by Curalate, Inc.
//

import { useConnectedInstagramAccountQuery } from '@account-settings/accountSettingsQueries';
import { IGetConnectedInstagramAccountResponse } from '@apis/instagram-settings/gatewayInstagramSettingsApiModel';
import {
  OnboardingStepInfo,
  OnboardingStepStatus,
} from '@welcome-page/constants/OnboardingConstants';

export const useOnboardingSocialStepInfo = (): OnboardingStepInfo => {
  const selectStepStatus = (data: IGetConnectedInstagramAccountResponse) =>
    data.data.connectedAccount?.businessAccountId
      ? OnboardingStepStatus.COMPLETE
      : OnboardingStepStatus.INCOMPLETE;

  const {
    data: status,
    isError,
    isPending,
  } = useConnectedInstagramAccountQuery(selectStepStatus);

  return {
    status: status ?? OnboardingStepStatus.INCOMPLETE,
    isPending,
    isError,
  };
};
